import type { FaqItem, Highlight, MapFeature, PainPoint, SamplePage, Stat, Testimonial, Volume } from '../types/landing';
export const heroMockup = 'https://cdn.magicpatterns.com/uploads/kTC36nsU6tHF8eXzGDS7fX/mockupcontab.jpg';
export const stats: Stat[] = [{
  value: '300',
  label: 'Mapas mentales'
}, {
  value: '10',
  label: 'Tomos organizados por temas'
}, {
  value: '5',
  label: 'Bonos de práctica incluidos'
}, {
  value: '30',
  label: 'Mapas por tomo'
}];
export const differenceParagraphs: string[] = ["", 'Primero comprendés el concepto. Después lo aplicás. Y con los bonos, comparás tus respuestas para detectar qué necesitás repasar.'];
export const differenceHighlights: Highlight[] = [{
  title: '300 mapas mentales visuales',
  body: 'Un tema por hoja para consultar con facilidad.'
}, {
  title: '10 tomos',
  body: 'Una secuencia desde los fundamentos hasta la integración de conceptos.'
}, {
  title: 'Teoría + práctica',
  body: 'Mapas para estudiar y actividades para poner a prueba lo aprendido.'
}];
export const beforeList: string[] = ['Pasás horas entre apuntes y videos buscando una explicación que finalmente entiendas.', 'Memorizás qué va en el Debe y qué va en el Haber, pero dudás cuando cambia el ejercicio.', 'Confundís ingresos con cobros y gastos con pagos.', 'Conocés las definiciones, pero te cuesta identificar qué cuentas intervienen.', 'Tenés ejercicios resueltos, pero no entendés por qué se hicieron así.', 'Llegás al parcial con temas leídos y poca práctica para resolver por tu cuenta.'];
export const afterList: string[] = ['Encontrá el tema que necesitás dentro de una colección organizada.', 'Relacioná conceptos, cuentas, operaciones y efectos patrimoniales.', 'Consultá ejemplos que te ayuden a entender el razonamiento.', 'Repasá los puntos centrales antes de una clase o un examen.', 'Practicá con consignas para completar antes de mirar las soluciones.', 'Detectá tus errores y volvé al mapa del concepto que necesitás reforzar.'];
export const painPoints: PainPoint[] = [{
  icon: '😵',
  title: 'Estudiás, pero después confundís los conceptos',
  body: 'En el momento parece claro. Cuando tenés que resolver un ejercicio, no sabés cómo empezar.'
}, {
  icon: '⏱️',
  title: 'Perdés demasiado tiempo buscando',
  body: 'Tenés material de sobra, pero necesitás encontrar una explicación concreta y ordenada.'
}, {
  icon: '🤷',
  title: 'No sabés qué repasar primero',
  body: 'Saltás entre temas sin tener claras las bases que necesitás para avanzar.'
}, {
  icon: '📚',
  title: 'Los textos largos se te hacen pesados',
  body: 'Leés varias páginas y te cuesta distinguir qué es lo importante.'
}, {
  icon: '🧠',
  title: 'Necesitás verlo para entenderlo',
  body: 'Te resulta más fácil estudiar cuando podés relacionar ideas, ejemplos y esquemas.'
}, {
  icon: '✍️',
  title: 'Entendés la teoría, pero te trabás al aplicarla',
  body: 'Necesitás practicar, equivocarte y comparar tus respuestas con una explicación.'
}];
export const mapFeatures: MapFeature[] = [{
  icon: '🧠',
  title: 'Organización visual',
  body: 'Conceptos agrupados y relacionados para seguir el tema con mayor claridad.'
}, {
  icon: '📖',
  title: 'Explicaciones en español',
  body: 'Definiciones y desarrollo de ideas para comprender el vocabulario contable.'
}, {
  icon: '🧾',
  title: 'Ejemplos contables',
  body: 'Situaciones que conectan los conceptos con operaciones y decisiones de registración.'
}, {
  icon: '🔗',
  title: 'Relaciones entre temas',
  body: 'Comprendé cómo una operación puede modificar recursos, deudas, patrimonio o resultados.'
}, {
  icon: '⚠️',
  title: 'Distinciones importantes',
  body: 'Prestá atención a diferencias que suelen generar confusión, como cobrar y ganar, pagar y consumir.'
}, {
  icon: '✍️',
  title: 'Práctica complementaria',
  body: 'Los bonos te permiten pasar del repaso a la resolución y revisar tus respuestas.'
}];
export const volumes: Volume[] = [{
  code: 'Tomo 1',
  title: 'Fundamentos de contabilidad',
  body: 'Empezá por las bases: para qué sirve la contabilidad, quién utiliza la información y cómo se relacionan los conceptos fundamentales.'
}, {
  code: 'Tomo 2',
  title: 'Documentación comercial',
  body: 'Comprendé la función de los comprobantes y su relación con las operaciones que respaldan.'
}, {
  code: 'Tomo 3',
  title: 'Cuentas y registración',
  body: 'Organizá tu comprensión de las cuentas, el Debe, el Haber y la registración de hechos económicos.'
}, {
  code: 'Tomo 4',
  title: 'Operaciones habituales',
  body: 'Relacioná las operaciones frecuentes con sus efectos contables y su registración.'
}, {
  code: 'Tomo 5',
  title: 'Rubros contables',
  body: 'Estudiá los principales grupos de cuentas y cómo se organiza la información patrimonial.'
}, {
  code: 'Tomo 6',
  title: 'Ajustes y cierre',
  body: 'Comprendé por qué se realizan ajustes y cómo se prepara la información al finalizar un período.'
}, {
  code: 'Tomo 7',
  title: 'Estados contables',
  body: 'Conectá la información registrada con los informes que muestran la situación y los resultados del ente.'
}, {
  code: 'Tomo 8',
  title: 'Introducción a costos',
  body: 'Incorporá las bases para comprender, clasificar y analizar costos.'
}, {
  code: 'Tomo 9',
  title: 'Análisis contable',
  body: 'Avanzá en la interpretación de la información contable y las relaciones entre sus componentes.'
}, {
  code: 'Tomo 10',
  title: 'Integrador',
  body: 'Relacioná los temas de la colección para abordar situaciones que combinan distintos conceptos.'
}];
export const samplePages: SamplePage[] = [{
  level: 'Ejemplo del Tomo 1',
  title: '¿Para qué sirve la contabilidad?',
  body: 'Comprendé qué observa, cómo procesa los hechos económicos y para qué se utiliza la información que produce.',
  image: 'https://cdn.magicpatterns.com/uploads/mq8Xj15EwDGsgQA8PpSYud/tomo1.jpg'
}, {
  level: 'Ejemplo del Tomo 2',
  title: 'Documentación comercial',
  body: 'Conocé el enfoque visual con el que vas a estudiar los comprobantes y su función.',
  image: 'https://cdn.magicpatterns.com/uploads/2Pm48p4RuwTbSxRHuG5oTs/tomo2.jpg'
}, {
  level: 'Ejemplo del Tomo 7',
  title: 'Estados contables',
  body: 'Explorá el material para relacionar los registros con la presentación de la información contable.',
  image: 'https://cdn.magicpatterns.com/uploads/cgtj7URTrvx2HzWLGdLMDw/tomo7.jpg'
}, {
  level: 'Ejemplo del Tomo 10',
  title: 'Integrador',
  image: 'https://cdn.magicpatterns.com/uploads/sF1DsozHtuL7gupMh6o3AA/tomo10.jpg'
}, {
  level: 'Ejemplo del Bono 1',
  title: 'Modo Parcial: 6 simulacros de contabilidad',
  image: 'https://cdn.magicpatterns.com/uploads/dPr1ti3rydpiEK12xuqbBk/bono1visual.jpg'
}, {
  level: 'Ejemplo del Bono 2',
  title: 'Guía de ejercicios para completar en Excel',
  image: 'https://cdn.magicpatterns.com/uploads/nP8LGXM32bTWSpTSRFsBLa/bono2visual.jpg'
}, {
  level: 'Ejemplo del Bono 3',
  title: 'Detective: encontrá y corregí 40 errores',
  image: 'https://cdn.magicpatterns.com/uploads/qPnzt6naZFohMTghxU3mZh/bono3visual.jpg'
}, {
  level: 'Ejemplo del Bono 4',
  title: '50 ejercicios + resultados',
  image: 'https://cdn.magicpatterns.com/uploads/aT5FBkVw9rXRn7ZCASYf3Y/bono4visual.jpg'
}, {
  level: 'Ejemplo del Bono 5',
  title: 'Del comprobante al asiento: 30 documentos para practicar',
  image: 'https://cdn.magicpatterns.com/uploads/5rUPgLcUUtWLQHrLNnEMp9/bono5visual.jpg'
}];
export const offerItems: string[] = ['10 tomos digitales de contabilidad.', '300 mapas mentales: 30 por tomo.', '6 simulacros con soluciones.', 'Kit de práctica en Excel con guía y ejemplo resuelto.', '40 casos para detectar y corregir errores.', '50 ejercicios para completar.', '30 documentos ficticios distribuidos en seis casos prácticos.'];
export const testimonials: Testimonial[] = [{
  quote: 'Me resultó cómodo tener los temas separados por tomo. Después de clase podía ir al mapa que necesitaba y repasar los conceptos que me habían quedado dando vueltas.',
  name: 'Lucía M. · Córdoba, Argentina',
  note: ""
}, {
  quote: 'Lo que más me gustó fue poder resolver primero y mirar las respuestas después. Me ayudó a reconocer cuándo entendía el ejercicio y cuándo estaba siguiendo un ejemplo de memoria.',
  name: 'Nicolás R. · Rosario, Santa Fe',
  note: ""
}, {
  quote: 'Buscaba material visual para acompañar mis apuntes. Tener los mapas y una parte de práctica en el mismo pack me resultó útil para ordenar las sesiones de estudio.',
  name: 'Camila S. · La Plata, Buenos Aires',
  note: ""
}];
export const faqItems: FaqItem[] = [{
  question: '¿Es un producto físico?',
  answer: ['No. Recibís material digital: los tomos y cuadernos en PDF, más los archivos de Excel del bono 2.']
}, {
  question: '¿Puedo imprimirlo?',
  answer: ['Sí. Podés imprimir los mapas y las hojas de práctica para estudiar y completar a mano.']
}, {
  question: '¿Sirve si recién estoy empezando?',
  answer: ['La colección comienza con fundamentos y avanza hacia otros temas de contabilidad general. Podés empezar por el Tomo 1 y avanzar a medida que comprendés las bases.']
}, {
  question: '¿Está organizado por universidad o por año de carrera?',
  answer: ['Está organizado por temas. Podés usarlo como complemento de tu cursada y consultar los contenidos que coincidan con tu programa.']
}, {
  question: '¿Los ejercicios incluyen respuestas?',
  answer: ['Sí. Los bonos de práctica incluyen soluciones o ejemplos resueltos para que puedas comparar después de completar las actividades.']
}, {
  question: '¿Reemplaza las clases o la bibliografía de mi materia?',
  answer: ['Es un material complementario de estudio y práctica. Seguí también el programa, la bibliografía y los criterios que indique tu cátedra.']
}];